import classNames from "classnames";
import StoryDescriptionBlock from "components/atoms/StoryDescriptionBlock";
import StoryButton from "components/atoms/StoryButton";
import { LoyaltyOnboardingPopupPropsWithKey } from "./types";
import "./styles.sass";
import { LoyaltyInfoExperienceContainer } from "../../../containers/atoms/LoyaltyInfoExperienceContainer";

export const WIDTH_POPUP = 343;
export const GAP_CARD = 32;

const LOYALTY_DESCRIPTIONS = {
  title1: "loyalty.stories.title.1",
  titleInactive1: "loyalty.stories.title.1.inactive",
  description1: "loyalty.stories.description.1",
  descriptionInactive1: "loyalty.stories.description.1.inactive",
  title2: "loyalty.stories.title.2",
  titleInactive2: "loyalty.stories.title.2.inactive",
  description2: "loyalty.stories.description.2",
  descriptionInactive2: "loyalty.stories.description.2.inactive",
  title3: "loyalty.stories.title.3",
  titleInactive3: "loyalty.stories.title.3.inactive",
  description3: "loyalty.stories.description.3",
  descriptionInactive3: "loyalty.stories.description.3.inactive",
  title4: "loyalty.stories.title.4",
  titleInactive4: "loyalty.stories.title.4.inactive",
  description4: "loyalty.stories.description.4",
  descriptionInactive4: "loyalty.stories.description.4.inactive",
  title5: "loyalty.stories.title.5",
  titleInactive5: "loyalty.stories.title.5.inactive",
  description5: "loyalty.stories.description.5",
  descriptionInactive5: "loyalty.stories.description.5.inactive",
  title6: "loyalty.stories.title.6",
  titleInactive6: "loyalty.stories.title.6.inactive",
  description6: "loyalty.stories.description.6",
  descriptionInactive6: "loyalty.stories.description.6.inactive",
};

export const LOYALTY_ONBOARDING_DURATIONS = [
  { duration: 60000, isFinished: false, isProgress: true, key: "timer-1" },
  { duration: 60000, isFinished: false, isProgress: false, key: "timer-2" },
  { duration: 60000, isFinished: false, isProgress: false, key: "timer-3" },
  { duration: 60000, isFinished: false, isProgress: false, key: "timer-4" },
  { duration: 60000, isFinished: false, isProgress: false, key: "timer-5" },
  { duration: 60000, isFinished: false, isProgress: false, key: "timer-6" },
];

export const LOYALTY_ONBOARDING_POPUPS: LoyaltyOnboardingPopupPropsWithKey[] = [
  {
    key: "story-loyalty-1",
    isActive: true,
    content: ({ onNext, inactive }) => {
      const title = inactive
        ? LOYALTY_DESCRIPTIONS.titleInactive1
        : LOYALTY_DESCRIPTIONS.title1;
      const description = inactive
        ? LOYALTY_DESCRIPTIONS.descriptionInactive1
        : LOYALTY_DESCRIPTIONS.title1;

      return (
        <div className="LoyaltyOnboardingContent">
          <img
            src="https://diswdgcu9cfva.cloudfront.net/loyalty/onboarding/lion.webp"
            className="LoyaltyOnboardingContent__image"
            alt=""
          />
          <StoryDescriptionBlock
            title={title}
            description={description}
            className={classNames(
              "LoyaltyOnboardingContent__blockInfo",
              "LoyaltyOnboardingContent__blockInfo_first",
              inactive && "LoyaltyOnboardingContent__blockInfo_first_inactive",
            )}
            classNameTitle="LoyaltyOnboardingContent__title_first"
          />
          <div
            className={classNames(
              "LoyaltyOnboardingContent__buttonContainer",
              inactive && "LoyaltyOnboardingContent__buttonContainer_inactive",
            )}
          >
            <StoryButton
              label="loyalty.popup.onboard.button.next"
              handleClick={onNext}
            />
          </div>
        </div>
      );
    },
  },
  {
    key: "story-loyalty-2",
    isActive: false,
    content: ({ onNext, inactive }) => {
      const title = inactive
        ? LOYALTY_DESCRIPTIONS.titleInactive2
        : LOYALTY_DESCRIPTIONS.title2;
      const description = inactive
        ? LOYALTY_DESCRIPTIONS.descriptionInactive2
        : LOYALTY_DESCRIPTIONS.title2;

      return (
        <div className="LoyaltyOnboardingContent">
          <div className="LoyaltyOnboardingContent__secondImage">
            <img
              src="https://diswdgcu9cfva.cloudfront.net/loyalty/onboarding/slots.webp"
              className={classNames(
                "LoyaltyOnboardingContent__image",
                "LoyaltyOnboardingContent__image_second",
              )}
              alt=""
            />
          </div>

          <StoryDescriptionBlock
            title={title}
            description={description}
            className={classNames(
              "LoyaltyOnboardingContent__blockInfo",
              "LoyaltyOnboardingContent__blockInfo_second",
              inactive && "LoyaltyOnboardingContent__blockInfo_second_inactive",
            )}
          >
            {inactive ? null : <LoyaltyInfoExperienceContainer />}
          </StoryDescriptionBlock>
          <div
            className={classNames(
              "LoyaltyOnboardingContent__buttonContainer",
              inactive && "LoyaltyOnboardingContent__buttonContainer_inactive",
            )}
          >
            <StoryButton
              label="loyalty.popup.onboard.button.next"
              handleClick={onNext}
            />
          </div>
        </div>
      );
    },
  },
  {
    key: "story-loyalty-3",
    isActive: false,
    content: ({ onNext, inactive }) => {
      const title = inactive
        ? LOYALTY_DESCRIPTIONS.titleInactive3
        : LOYALTY_DESCRIPTIONS.title3;
      const description = inactive
        ? LOYALTY_DESCRIPTIONS.descriptionInactive3
        : LOYALTY_DESCRIPTIONS.title3;

      return (
        <div className="LoyaltyOnboardingContent">
          <img
            src="https://diswdgcu9cfva.cloudfront.net/loyalty/onboarding/chest.webp"
            alt=""
            className="LoyaltyOnboardingContent__image"
          />
          <StoryDescriptionBlock
            title={title}
            description={description}
            className={classNames(
              "LoyaltyOnboardingContent__blockInfo",
              "LoyaltyOnboardingContent__blockInfo_third",
              inactive && "LoyaltyOnboardingContent__blockInfo_third_inactive",
            )}
            classNameTitle="LoyaltyOnboardingContent__title_third"
          />
          <div
            className={classNames(
              "LoyaltyOnboardingContent__buttonContainer",
              inactive && "LoyaltyOnboardingContent__buttonContainer_inactive",
            )}
          >
            <StoryButton
              label="loyalty.popup.onboard.button.next"
              handleClick={onNext}
            />
          </div>
        </div>
      );
    },
  },
  {
    key: "story-loyalty-4",
    isActive: false,
    content: ({ onNext, inactive }) => {
      const title = inactive
        ? LOYALTY_DESCRIPTIONS.titleInactive4
        : LOYALTY_DESCRIPTIONS.title4;
      const description = inactive
        ? LOYALTY_DESCRIPTIONS.descriptionInactive4
        : LOYALTY_DESCRIPTIONS.title4;

      return (
        <div className="LoyaltyOnboardingContent">
          <img
            src="https://diswdgcu9cfva.cloudfront.net/loyalty/onboarding/cup.webp"
            alt=""
            className="LoyaltyOnboardingContent__image"
          />
          <StoryDescriptionBlock
            title={title}
            description={description}
            className={classNames(
              "LoyaltyOnboardingContent__blockInfo",
              "LoyaltyOnboardingContent__blockInfo_four",
              inactive && "LoyaltyOnboardingContent__blockInfo_four_inactive",
            )}
            classNameTitle="LoyaltyOnboardingContent__title_third"
          />
          <div
            className={classNames(
              "LoyaltyOnboardingContent__buttonContainer",
              inactive && "LoyaltyOnboardingContent__buttonContainer_inactive",
            )}
          >
            <StoryButton
              label="loyalty.popup.onboard.button.next"
              handleClick={onNext}
            />
          </div>
        </div>
      );
    },
  },
  {
    key: "story-loyalty-5",
    isActive: false,
    content: ({ onNext, inactive }) => {
      const title = inactive
        ? LOYALTY_DESCRIPTIONS.titleInactive5
        : LOYALTY_DESCRIPTIONS.title5;
      const description = inactive
        ? LOYALTY_DESCRIPTIONS.descriptionInactive5
        : LOYALTY_DESCRIPTIONS.title5;

      return (
        <div className="LoyaltyOnboardingContent">
          <div className="LoyaltyOnboardingContent__boosterImage">
            <img
              src="https://diswdgcu9cfva.cloudfront.net/loyalty/onboarding/booster.webp"
              className={classNames(
                "LoyaltyOnboardingContent__image",
                "LoyaltyOnboardingContent__image_booster",
              )}
              alt=""
            />
          </div>
          <StoryDescriptionBlock
            title={title}
            description={description}
            className={classNames(
              "LoyaltyOnboardingContent__blockInfo",
              "LoyaltyOnboardingContent__blockInfo_five",
              inactive && "LoyaltyOnboardingContent__blockInfo_five_inactive",
            )}
            classNameTitle="LoyaltyOnboardingContent__title_five"
          />
          <div
            className={classNames(
              "LoyaltyOnboardingContent__buttonContainer",
              inactive && "LoyaltyOnboardingContent__buttonContainer_inactive",
            )}
          >
            <StoryButton
              label="loyalty.popup.onboard.button.next"
              handleClick={onNext}
            />
          </div>
        </div>
      );
    },
  },
  {
    key: "story-loyalty-6",
    isActive: false,
    content: ({ onNext, inactive }) => {
      const title = inactive
        ? LOYALTY_DESCRIPTIONS.titleInactive6
        : LOYALTY_DESCRIPTIONS.title6;
      const description = inactive
        ? LOYALTY_DESCRIPTIONS.descriptionInactive6
        : LOYALTY_DESCRIPTIONS.title6;

      return (
        <div className="LoyaltyOnboardingContent">
          <img
            src="https://diswdgcu9cfva.cloudfront.net/loyalty/onboarding/lions.webp"
            alt=""
            className="LoyaltyOnboardingContent__image"
          />
          <StoryDescriptionBlock
            title={title}
            description={description}
            className={classNames(
              "LoyaltyOnboardingContent__blockInfo",
              "LoyaltyOnboardingContent__blockInfo_six",
              inactive && "LoyaltyOnboardingContent__blockInfo_six_inactive",
            )}
          />
          <div
            className={classNames(
              "LoyaltyOnboardingContent__buttonContainer",
              inactive && "LoyaltyOnboardingContent__buttonContainer_inactive",
            )}
          >
            <StoryButton
              label="loyalty.popup.onboard.button.complete"
              handleClick={onNext}
            />
          </div>
        </div>
      );
    },
  },
];
